// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-wrapper {
  position: relative;
  width: 100%;
  height: 40px;
}
.input-wrapper::before {
  content: url("/assets/media/general/search.svg");
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-45%);
}
.input-wrapper .input-class {
  border: 1px solid #DFE2EA;
  background: #F4F5F8;
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 10px;
  width: 100%;
  height: 40px;
}
.input-wrapper .input-class::placeholder {
  color: #868AA8;
  font-family: Cairo;
  font-size: 14px;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/search-v2/search-v2.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AACJ;AACI;EACE,gDAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AACN;AAEI;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAAN;AAEM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAAR","sourcesContent":[".input-wrapper {\n    position: relative;\n    width: 100%;\n    height: 40px;\n\n    &::before {\n      content: url('/assets/media/general/search.svg');\n      position: absolute;\n      left: 10px;\n      top: 50%;\n      transform: translateY(-45%);\n    }\n  \n    .input-class {\n      border: 1px solid #DFE2EA;\n      background: #F4F5F8;\n      padding-left: 40px; \n      padding-right: 30px;\n      padding-top: 10px;\n      padding-bottom: 10px;\n      border-radius: 10px;\n      width: 100%;\n      height: 40px;\n\n      &::placeholder {\n        color: #868AA8;\n        font-family: Cairo;\n        font-size: 14px;\n        font-weight: 400;\n      }\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
